export default __webpack_public_path__ + "static/media/evreux2.1caa509e.jpg";